import { Link } from "react-router-dom";
import { Button } from "bizpandit-ui";
import { useAuthStore } from "@/stores/authStore";
import { pickHomeForRole } from "@/app/router/roleHome";

export function NotFoundPage() {
  const role = useAuthStore((s) => s.user?.role);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 text-center px-6">
      <p className="text-6xl font-bold text-navy2/60">404</p>
      <h1 className="text-xl font-semibold">Page not found</h1>
      <p className="max-w-sm text-sm text-navy2/60">
        The page you&apos;re looking for doesn&apos;t exist or has been moved.
      </p>
      <Button asChild>
        <Link to={pickHomeForRole(role)}>Back to home</Link>
      </Button>
    </div>
  );
}
